import { render, staticRenderFns } from "./VirtualNodesActive.vue?vue&type=template&id=a0d38572"
import script from "./VirtualNodesActive.vue?vue&type=script&lang=ts"
export * from "./VirtualNodesActive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports